import PopNotification from './PopNotification.component';

export default PopNotification;